/**
 * @file Pinia Store 入口
 * @description 创建全局 Pinia 实例，注册持久化插件，并统一导出业务 Store。
 */
import { createPinia } from 'pinia'
import persist from 'pinia-plugin-persistedstate'

/** 应用全局 Pinia 实例 */
const pinia = createPinia()
pinia.use(persist)

export default pinia

// 导出所有业务 Store，保持页面侧 import 入口稳定。
export * from './modules/loginUser'
export * from './modules/cachedDataStores'
export * from './modules/routeRefresh'
export * from './modules/theme'
export * from './modules/navLayout'
export * from './modules/grayRelease'
